import { useCallback, useEffect, useState } from "react";
import { errMsg } from "@/lib/api";

export function useGet(api, path) {
  const [data, setData] = useState(null);
  const [err, setErr] = useState("");
  const load = useCallback(() => { if (path) api.get(path).then((r) => { setData(r.data); setErr(""); }).catch((e) => setErr(errMsg(e))); }, [api, path]);
  useEffect(() => { load(); }, [load]);
  return [data, err, load];
}

export const STATUS = {
  received: ["Received", "bg-gray-100 text-gray-700"],
  ai_reading: ["AI reading", "bg-sky-100 text-sky-800"],
  ready: ["Ready to check", "bg-amber-100 text-amber-800"],
  approved: ["Approved", "bg-green-100 text-green-800"],
  sent_back: ["Sent back", "bg-red-100 text-red-700"],
  duplicate: ["Duplicate", "bg-purple-100 text-purple-800"],
  cancelled: ["Cancelled", "bg-gray-100 text-gray-500"],
};

export const StatusBadge = ({ s, testid }) => {
  const [l, c] = STATUS[s] || [s, "bg-gray-100"];
  return <span className={`whitespace-nowrap rounded-full px-2 py-0.5 text-[11px] font-bold ${c}`} data-testid={testid}>{l}</span>;
};

export const waitText = (m) => (m < 60 ? `${m} min` : m < 1440 ? `${Math.floor(m / 60)} h ${m % 60} min` : `${Math.floor(m / 1440)} d`);

// Doctor shorthand → slots + food
export function parseShorthand(raw) {
  const t = (raw || "").trim().toUpperCase().replace(/\s+/g, " ");
  const out = {};
  const m = t.match(/^([01])\s*-\s*([01])\s*-\s*([01])/);
  if (m) out.slots = ["morning", "afternoon", "night"].filter((_, i) => m[i + 1] === "1");
  const map = { OD: ["morning"], BD: ["morning", "night"], TDS: ["morning", "afternoon", "night"], QID: ["morning", "afternoon", "night"], HS: ["night"] };
  Object.entries(map).forEach(([k, v]) => { if (new RegExp(`\\b${k}\\b`).test(t)) out.slots = v; });
  if (/\bHS\b/.test(t)) out.food = "bedtime";
  if (/\bAC\b/.test(t)) out.food = "before";
  if (/\bPC\b/.test(t)) out.food = "after";
  const d = t.match(/X\s*(\d+)\s*(DAY|DAYS|D)\b/);
  if (d) { out.days = Number(d[1]); out.long_term = false; }
  const mo = t.match(/X\s*(\d+)\s*(MONTH|MONTHS)\b/);
  if (mo) { out.days = Number(mo[1]) * 30; out.long_term = false; }
  if (/\bSOS\b/.test(t)) out.sos = true;
  return out;
}
